import type { TokenIssueResult, TokenResponse } from '@app/types/sdk';

export const isTokenResponse = (value: TokenIssueResult): value is TokenResponse => {
  return value != null && typeof value === 'object' && 'accessToken' in value && typeof (value as TokenResponse).accessToken === 'string';
};

export const getTokenResponseOrThrow = (value: TokenIssueResult): TokenResponse => {
  if (!isTokenResponse(value)) {
    throw new Error('Token exchange did not return session tokens.');
  }
  return value;
};
